import UserBasicInfoSettingsStore from './UserBasicInfoSettingsStore'

export default UserBasicInfoSettingsStore
